import { useEffect, useState } from 'react';
import { getPurchaseOrders } from '../../redux/api/faculty';
import { useSnackbar } from 'react-simple-snackbar';
import { optionsStyle } from '../../utils/snackStyles';
import { useErpPa } from '../../pages/faculty/contexts/ErpPaProvider';

const useSettlements = () => {
    const [settlements, setSettlements] = useState(null);
    const [initialValues, setInitialValues] = useState(null);
    const [faculty, setFaculty] = useState(null);
    const [states, setStates] = useState([]);

    const [openSnackbar] = useSnackbar(optionsStyle);

    //guardo ERP Panama del profesor
    const { saveErpPaId } = useErpPa();

    useEffect(() => {
        !settlements && getData();
        // eslint-disable-next-line
    }, []);

    //Se modifico estructura del ep, se pasa propiedad reponse_data.purchase_orders
    const getData = async () => {
        const req = await getPurchaseOrders();
        if (req.error) {
            openSnackbar('¡No se pudieron cargar los datos!');
            setSettlements([]);
            return;
        } else {
            setSettlements(req?.purchase_orders);
            setInitialValues(req?.purchase_orders);
            handleInformation(req?.purchase_orders);
            getStatusPay(req.purchase_orders);
            saveErpPaId(req?.erp_pa_id);
        }
    };

    const handleInformation = (values) => {
        // Monto en dolar
        const dollar = values
            .filter(
                (item) => item.currency === 'USD' && item.state === 'purchase'
            )
            .reduce((acc, current) => acc + current.amount, 0);
        // Monto en moneda local
        const localCurrency = values
            .filter(
                (item) => item.currency !== 'USD' && item.state === 'purchase'
            )
            .reduce((acc, current) => acc + current.amount, 0);
        // Pagos a autorizar
        const draftForPay = values.filter(
            (item) => item.state === 'draft'
        ).length;
        // Pagos autorizados
        const draftPay = values.filter(
            (item) => item.state === 'purchase'
        ).length;

        setFaculty({ dollar, localCurrency, draftForPay, draftPay });
    };

    const getStatusPay = (values) => {
        const states = values.map((item) => item.state);
        const stateClean = Array.from(new Set(states));
        const sanitizerStates = stateClean.map((item) => {
            const cases = {
                done: { id: item, name: 'Bloqueado' },
                cancel: { id: item, name: 'Cancelado' },
                draft: { id: item, name: 'A autorizar' },
                'paid out': { id: item, name: 'Pagado' },
                'to approve': { id: item, name: 'Aprobado' },
                sent: { id: item, name: 'Cotización enviada' },
                check: { id: item, name: 'Revisado' },
                purchase: { id: item, name: 'Petición de compra' },
            };
            return cases[item];
        });
        setStates(sanitizerStates);
    };

    const handleSettlements = (newData) => {
        setSettlements(newData);
    };

    const handleRefresh = () => {
        getData();
    };

    return {
        settlements,
        initialValues,
        handleSettlements,
        handleRefresh,
        faculty,
        states,
    };
};

export default useSettlements;
